import { _ } from "extensions/underscore";

import { ViewMixin } from "extensions/_viewMixin";

export class Presenter {
    constructor() {
        Object.assign(this, ViewMixin);
    }
    
    present(column, content, rowModelData, rowModel) {
        const templateData = {};
        
        templateData.className = this.itemClassName(column, content, rowModelData, rowModel);
        templateData.content = this.getCellContent(column, content, rowModelData, rowModel);
        templateData.modelAttribute = column.attribute;
        templateData.csvtext = this.getCSVtext(column, content, rowModelData, rowModel);
        
        if (typeof column.beforeRender === "function") {
            templateData.content = column.beforeRender(templateData.content, rowModelData, rowModel, column, content);
        }
        
        return templateData;
    }
    
    getCSVtext(column, content, rowModelData, rowModel) {
        if (content === null) {
            return column.cellOptions.emptyString;
        }
        
        const csvTextProp = _.propValue(column, "cellOptions.csvtext");
        
        if (csvTextProp) {
            return _.resultPartial(csvTextProp, null, "", rowModel);
        }
        
        if (_.isFunction(this.getCSVContent)) {
            return this.getCSVContent(column, content, rowModelData, rowModel);
        }
        
        return "";
    }
    
    getCellContent(column, content, rowModelData, rowModel) {
        if (content === null) {
            return column.cellOptions.emptyString;
        }
        
        return this.itemContent(column, content, rowModelData, rowModel);
    }
    
    static valueToClassNameByCellOptionsMap(column, content, rowModelData, rowModel) {
        const className = [];
        if (_.propValue(column, "cellOptions.map")) {
            const mapProp = _(column.cellOptions.map).findWhere({
                value: content
            });
            if (mapProp) {
                className.push(mapProp.cellClassName);
            }
        }
        
        if (column.cellClassName) {
            className.push(_.resultPartial(column, "cellClassName", "", rowModel, content));
        }
        
        return className;
    }
    
    // Subclasses should utilize this method to add additional classes to the cell
    // eslint-disable-next-line class-methods-use-this
    additionalValueClassNames() {
        return [];
    }
    
    itemClassName(column, content, rowModelData, rowModel) {
        const classNames = [_.isFunction(column.cell) ? column.cell(content) : column.cell];
        
        // Set class based on the current value
        const valueByCellOptionsClass = Presenter.valueToClassNameByCellOptionsMap(column, content, rowModelData, rowModel);
        const additionalClassNames = this.additionalValueClassNames(column, content, rowModelData, rowModel);
        
        return [...classNames, ...valueByCellOptionsClass, ...additionalClassNames].join(" ");
    }
    
    // eslint-disable-next-line class-methods-use-this
    itemContent(column, content, rowModelData, rowModel) {
        return content;
    }
}
